export const isValidNonEmptyJSON = (str) => {
    try {
        const jsonObj = JSON.parse(str);
        if (typeof jsonObj === 'object' && Object.keys(jsonObj).length > 0) {
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
